<template>
  <div>
    <div>
      <SmartTitle
        weight="medium"
        class="main-title"
      >
        Configurador de Produtos
      </SmartTitle>
      <div v-if="!loading">
        <VDataTable
          :items="listProductGetter"
          hide-actions
          hide-default-header
          :headers="headers"
          class="main-title my-4"
        >
          <template v-slot:items="{ item, index }">
            <td class="force-text-black">
              <span class="force-text-black">{{ item.name || '-' }}</span>
            </td>
            <td
              class="view-icon"
              width="100"
            >
              <label class="flex flex-row align-center justify-center cursor-pointer">
                <SmartCheckbox
                  v-model="selectedProducts[index]"
                  label=" "
                  class="p-1 rounded"
                />
              </label>
            </td>
          </template>
        </VDataTable>
        <div class="flex justify-end">
          <SmartButton @click="save">
            Salvar
          </SmartButton>
        </div>
      </div>
      <SmartCard
        class="mt-1 p-3"
        v-else
      >
        <SmartSkeletonLoading
          :items="11"
          :height="4"
        />
      </SmartCard>
    </div>
    <SmartModal v-if="modal" v-bind="modal" @close="closeModal">{{ modal.text }}</SmartModal>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ProductSettings',

  data() {
    return {
      loading: false,
      selectedProducts: [],
      productsIds: [],
      modal: null,
      headers: [
        { text: 'Produto', value: 'product', sortable: false },
        { text: 'Status', value: 'status', sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters({
      listProductGetter: 'productSetting/listProductGetter'
    })
  },
  methods: {
    ...mapActions({
      fetchList: 'productSetting/fetchList',
      saveProducts: 'productSetting/saveProducts'
    }),
    save() {
      let products = [];

      this.selectedProducts.map((value, index) => {
        if (value) {
          products.push(this.productsIds[index]);
        }
      });

      this.showLoadingModal();
      this.saveProducts(products)
        .then(this.showSuccessModal)
        .catch(this.showErrorModal);
    },
    showErrorModal() {
      this.modal = {
        type: 'warning',
        title: 'Ops!',
        icon: 'alert',
        buttonText: 'Tentar novamente',
        text: 'Algo deu errado!'
      };
    },
    showLoadingModal() {
      this.modal = {
        type: 'default',
        title: 'Carregando...',
        icon: 'union',
        text: 'Estamos subindo a configuração, aguarde um instante...'
      };
    },
    showSuccessModal({ data }) {
      this.modal = {
        type: 'success',
        title: 'Produtos salvos',
        icon: 'accepted',
        buttonText: 'Ok',
        text: data.message
      };
    },
    closeModal() {
      this.modal = null;
      this.$emit('close');
    }
  },
  async mounted() {
    this.loading = true;
    await this.fetchList();
    this.loading = false;

    this.listProductGetter.forEach((item) => {
      this.selectedProducts.push(item.status === 1);
      this.productsIds.push(item.segment_id);
    });
  }
};
</script>

<style>

</style>
